import { Modal, Typography } from 'antd';

import { Button } from '@shared/components/Button';

const { Text } = Typography;

interface Props {
  handleCancel: () => void;
  handleRemovePhoto: () => void;
  handleReplacePhoto: () => void;
  isShowOptionsModal: boolean;
  onCancel: () => void;
}
const OptionsModal = ({ handleCancel, handleRemovePhoto, handleReplacePhoto, isShowOptionsModal, onCancel }: Props) => (
  <Modal centered closable={false} footer={null} maskClosable={false} onCancel={onCancel} open={isShowOptionsModal}>
    <div className="mx-auto flex w-3/4 flex-col items-center justify-center py-4">
      <Text className="text-base font-semibold">Edit Photo</Text>
      <div className="mt-3 flex w-full flex-col gap-5">
        <Button className="json-checked w-full" onClick={handleReplacePhoto} variant="secondary">
          Replace profile photo
        </Button>
        <Button className="json-checked w-full" onClick={handleRemovePhoto} variant="secondary">
          Remove profile photo
        </Button>
        <Button className="json-checked mt-6 w-full" onClick={handleCancel} variant="secondary">
          Cancel
        </Button>
      </div>
    </div>
  </Modal>
);

export default OptionsModal;
